import React from 'react';
import {
  Typography, Link, FormControlLabel, Checkbox,
} from '@mui/material';
import useStyles from './styles';
import analytics from '../../utils/analytics';
import { Partner } from '../LeadFormIndex/types';
import { theme } from '../../theme';

type TermsAndConditionsLinkType = {
  origin: string,
  checked: boolean,
  handleSetChecked: () => void,
  partner: Partner,
  formControlLabelProps?: {
    backgroundColor?: string,
    padding?: number | string,
    borderRadius?: number,
    margin?: number | string,
  },
  additionalText?: React.ReactNode,
};

const privacyPolicyUrlByPartnerName = (partnerName: string) => {
  switch (partnerName) {
    case 'Enlace Inmobiliario':
      return 'https://www.banca.me/recursos/legal/politica-privacidad-enlace-inmobiliario';
    default:
      return 'https://www.banca.me/recursos/legal/politica-privacidad';
  }
};

export default function TermsAndConditionsLink(props: TermsAndConditionsLinkType) {
  const classes = useStyles();
  const {
    origin, checked, handleSetChecked, partner,
    formControlLabelProps, additionalText,
  } = props;
  const handleCheckBox = () => {
    analytics.track('Click Checkbox', {
      text: 'Acepto los TyC y política privacidad',
      initiator: 'usuario',
    });
    handleSetChecked();
  };
  const handleClickTermsAndConditions = () => {
    analytics.track('Click Link', {
      text: 'términos y condiciones',
      initiator: 'usuario',
    });
  };
  const handleClickPrivacyPolicy = () => {
    analytics.track('Click Link', {
      text: 'política de privacidad',
      initiator: 'usuario',
    });
  };
  return (
    <FormControlLabel
      style={formControlLabelProps}
      control={(
        <Checkbox
          size="small"
          checked={checked}
          onClick={handleCheckBox}
          data-pw="preloan-default-optIn"
        />
          )}
      label={(
        <Typography className={classes.termsAndConditions} align="left" variant="body2">
          Acepto los
          {' '}
          <Link
            onClick={handleClickTermsAndConditions}
            style={{ textDecoration: 'underline', color: partner.config.styles?.secondaryColor }}
            href={`/terms-and-conditions?origin=${origin}&referrer=plr`}
            target="_blank"
            rel="noopener"
          >
            términos y condiciones
          </Link>
          {' '}
          y
          {' '}
          <Link
            onClick={handleClickPrivacyPolicy}
            style={{ textDecoration: 'underline', color: partner.config.styles?.secondaryColor }}
            href={privacyPolicyUrlByPartnerName(partner.partnerName)}
            target="_blank"
            rel="noopener"
          >
            política de privacidad
          </Link>
          {additionalText}
        </Typography>
          )}
    />

  );
}

TermsAndConditionsLink.defaultProps = {
  formControlLabelProps: {
    backgroundColor: theme.palette.background.defaultSecondary,
    padding: 10,
    borderRadius: 20,
    margin: 'auto',
  },
  additionalText: ', lo que incluye la consulta de cuentas y deudas asociadas a mi RUT',
};
